import React, { Fragment, useState } from "react";
import "../documentation.css";
import { formatTimestamp } from "../helpers";
import { DoneIcon, TodoIcon } from "../../assets/Icons";
import ssowObj from "./ssowObj";
import CandImage from "../Components/CandImage";
import Initials from "../Components/Initials";

const CarltonForestDocuments = ({
  candidates,
  ssow,
  readingList,
  images,
  passImage,
  handleOverlay,
  getReadingListPdf,
  downloadRef
}) => {
  const [selected, setSelected] = useState(null);
  const [lineSelected, setLineSelected] = useState();
  const [highlightBtn, setHighlightBtn] = useState("");

  const candidateSSOW = ssow || {};

  const handleDownloadForm = candidate => {
    getReadingListPdf(
      candidate.candidateRef,
      candidate.firstName,
      candidate.lastName
    );
  };

  const isInductionCheckListComplete = c =>
    c.nonReadingListDocs.YCFG ? (
      <div className="tooltip">
        <button
          onClick={() => handleDownloadForm(c)}
          style={{
            fontSize: "14px",
            backgroundColor: "white",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #2196f3"
          }}
        >
          Download
        </button>
        <div className="tooltiptext">
          Signed {c.nonReadingListDocs && c.nonReadingListDocs.NCF1}
        </div>
      </div>
    ) : (
      <div className="tw-w-full tw-flex tw-justify-center">
        <TodoIcon />
      </div>
    );

  const isRead = (c, r) => {
    if (c.documents && c.documents.readings && c.documents.readings[r]) {
      return (
        <div className="tooltip">
          <DoneIcon />
          <div className="tooltiptext">
            Signed {formatTimestamp(c.documents.readings[r])}
          </div>
        </div>
      );
    }
    return (
      <div className="tooltip">
        <TodoIcon />
      </div>
    );
  };

  const ViewButton = ({ id, fn, num }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-content-center tw-flex-1 tw-py-10">
      <button
        className={`${id === highlightBtn &&
          "tw-border-blue-400 tw-text-white tw-bg-blue-400 tw-border-2"} tw-bg-blue-200' tw-bg-blue-100 tw-p-2 lg:tw-w-1/2 tw-w-full tw-rounded-lg ${id !==
          highlightBtn &&
          "hover:tw-bg-blue-200 hover:tw-border-blue-500"} tw-border-blue-300 tw-border-2 tw-cursor-pointer`}
        onClick={fn}
      >
        <span className="md:tw-inline tw-hidden">View</span>
        <span className="md:tw-hidden tw-inline">{num}</span>
      </button>
    </div>
  );

  const SSOW = ssowObj;

  const getDocCount = (line, candidateRef) => {
    const values = Object.values(SSOW[line]);

    if (!values) return undefined;
    let readCount = 0;
    values.forEach(row => {
      const { id } = row;
      const read =
        candidateSSOW[candidateRef] &&
        candidateSSOW[candidateRef][lineSelected] &&
        candidateSSOW[candidateRef][lineSelected][id];
      if (read) readCount += 1;
    });
    return { readCount };
  };

  const FileContainer = ({ title, read = false, readTimestamp = "" }) => (
    <div className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center">
      <p className="tw-mb-1">{title}</p>
      <div
        className="tw-w-full tw-h-full tw-flex"
        style={{ alignItems: "end" }}
      >
        <div className="tw-flex-1 tw-flex-col tw-py-2">
          {read ? (
            <div className="tooltip">
              <DoneIcon />
              <div className="tooltiptext">
                Read {formatTimestamp(readTimestamp)}
              </div>
            </div>
          ) : (
            <div className="tooltip">
              <TodoIcon />
            </div>
          )}
          <p className=""></p>
          <p className="tw-pt-2">Read</p>
        </div>
      </div>
    </div>
  );
  const populateDropRow = (line, candidateRef) => {
    const values = SSOW[line];
    if (!values) return undefined;

    return values.map((row, i) => {
      const { id, title } = row;
      const read =
        candidateSSOW[candidateRef] &&
        candidateSSOW[candidateRef][lineSelected] &&
        candidateSSOW[candidateRef][lineSelected][id]; // current person, current line (docs) and current doc - if present they have read the document

      if (read) {
        return (
          <FileContainer
            key={i}
            title={title}
            read={read}
            readTimestamp={read}
          />
        );
      }
      return <FileContainer key={i} title={title} />;
    });
  };

  const Header = ({
    title,
    line,
    countObj = { readCount: 0, signedCount: 0 }
  }) => (
    <div className="tw-w-full tw-flex md:tw-flex-row tw-flex-col md:tw-justify-between tw-items-start md:tw-p-5 tw-p-3">
      <p className="md:tw-pl-2 tw-pl-0 tw-text-md tw-pb-2">{title}</p>
      <div className="tw-w-auto tw-flex md:tw-justify-between tw-mr-2">
        <span>
          {countObj.readCount}/{Object.values(SSOW[line]).length} documents read{" "}
        </span>
      </div>
    </div>
  );

  const getSSOWTitle = line => {
    if (line === "handBaller") return "Hand Baller Operative SSOW -";
    if (line === "mhe") return "MHE Operative SSOW -";
    return "";
  };

  const setState = (i, line) => {
    if (selected === i && line === lineSelected) {
      setSelected(null);
      setLineSelected(null);
    } else {
      setSelected(i);
      setLineSelected(line);
    }
  };

  const setHighligtning = key =>
    highlightBtn === key ? setHighlightBtn("") : setHighlightBtn(key);

  return (
    <div>
      <div className="tw-rounded-md tw-overflow-x-auto ">
        <div className="tw-align-middle tw-rounded-md tw-inline-block tw-min-w-full">
          <div className="tw-shadow tw-rounded-md tw-overflow-hidden tw-border-b tw-border-gray-200 ">
            <table className="tw-overflow-x tw-border-collapse tw-min-w-full tw-border-2 tw-border-gray-500 tw-rounded-md tw-mb-8 tw-divide-y tw-divide-gray-200">
              <thead className="tw-border-collapse tw-bg-gray-50 tw-rounded-md tw-border-0 tw-border-gray-500 ">
                <tr>
                  <th
                    scope="tw-col"
                    style={{ width: "25%" }}
                    className="tw-py-4 tw-px-2 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    Worker
                  </th>
                  {readingList.map(doc => (
                    <th
                      key={doc.name}
                      scope="col"
                      className="tw-py-4 tw-px-2 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                    >
                      {doc.name}
                    </th>
                  ))}
                  <th
                    key="ssow"
                    scope="col"
                    className="tw-w-full tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    <div className="tw-flex tw-flex-col tw-min-h-full tw-border-black">
                      <span className="tw-p-5">
                        {" "}
                        Safe System of Work Procedure (SSOW){" "}
                      </span>
                      <div className="tw-min-w-full tw-h-14 tw-w-full tw-flex tw-border-t-2 tw-border-gray-500 ">
                        <p className="tw-flex-1 sm:tw-pt-3 tw-pt-0 tw-border-r-2 tw-border-gray-500">
                          Hand Baller Operative
                        </p>
                        <p className="tw-flex-1 sm:tw-pt-3 tw-pt-0 tw-border-r-2 tw-border-gray-500">
                          MHE Operative
                        </p>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
                {candidates.map((c, i) => (
                  <Fragment key={i}>
                    <tr className="reading-list__rows">
                      <td className="tw-text-sm">
                        <div className="tw-flex lg:tw-flex-row tw-flex-col tw-w-full lg:tw-items-center md:tw-text-left tw-text-center">
                          {images && images[c.candidateRef] ? (
                            <CandImage
                              handleOverlay={handleOverlay}
                              passImage={passImage}
                              image={images[c.candidateRef]}
                              firstName={c.firstName}
                            />
                          ) : (
                            <Initials
                              firstName={c.firstName}
                              lastName={c.lastName}
                            />
                          )}
                          <p className="tw-font-bold tw-font-lg lg:tw-pl-0 tw-pl-1">
                            {c.firstName} {c.lastName}
                          </p>
                        </div>
                      </td>
                      {readingList.map((r, index) => (
                        <td className="tw-p-2" key={`th${index}`}>
                          {" "}
                          {r.filename === "carlton_forest_induction.pdf"
                            ? isInductionCheckListComplete(c)
                            : isRead(c, r.filename)}{" "}
                        </td>
                      ))}
                      <td>
                        <div
                          className={`tw-flex tw-min-h-full tw-w-full tw-min-w-fit`}
                        >
                          <ViewButton
                            id={`${i}${c.lastName}HB`}
                            fn={() => {
                              setState(i, "handBaller");
                              setHighligtning(`${i}${c.lastName}`);
                            }}
                            num="HB"
                          />
                          <ViewButton
                            id={`${i}${c.lastName}ME`}
                            fn={() => {
                              setState(i, "mhe");
                              setHighligtning(`${i}${c.lastName}`);
                            }}
                            num="ME"
                          />
                        </div>
                      </td>
                    </tr>
                    {selected === i ? (
                      <tr>
                        <td colSpan="6">
                          <Header
                            line={lineSelected}
                            title={`${getSSOWTitle(lineSelected)} ${
                              c.firstName
                            } ${c.lastName}`}
                            countObj={getDocCount(lineSelected, c.candidateRef)}
                          />
                          <div className="tw-flex tw-min-w-full tw-overflow-y-auto tw-flex-wrap tw-pb-4 tw-px-0 tw-justify-center tw-items-center">
                            {populateDropRow(lineSelected, c.candidateRef)}
                          </div>
                        </td>
                      </tr>
                    ) : null}
                  </Fragment>
                ))}
              </tbody>
            </table>
            <a className="d-none" ref={downloadRef}></a>
          </div>
        </div>
      </div>
      <a className="d-none" ref={downloadRef}></a>
    </div>
  );
};

export default CarltonForestDocuments;
